import { TeamOutlined } from '@ant-design/icons';

const users = {
    id: 'group-users',
    title: 'User Management',
    type: 'group',
    children: [
        {
            id: 'users',
            title: 'Users',
            type: 'item',
            url: '/users',
            icon: TeamOutlined,
        },
    ],
};

export default users;
